import { CostCenter, WbsCode, WbsCodeCostCenterMergedType } from '~/api/types';
import { v2Api } from '../v2Api';

const tags = ['wbs-code'] as const;

const wbsCodeApi = v2Api
  .enhanceEndpoints({
    addTagTypes: tags,
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getWbsCodes: builder.query<WbsCodeCostCenterMergedType[], { search?: string }>({
        query: ({ search }) => `wbs-code/search/merged?search=${encodeURIComponent(search ?? '')}`,
        providesTags: tags,
        transformResponse: (response: { data: WbsCodeCostCenterMergedType[] }) => response.data,
      }),
      getWbsCode: builder.query<WbsCode, { id: number }>({
        query: ({ id }) => `wbs-code/${id}`,
        providesTags: tags,
        transformResponse: (response: { data: WbsCode }) => response.data,
      }),
      getСostCenter: builder.query<CostCenter, { id: number }>({
        query: ({ id }) => `wbs-code/cost-center/${id}`,
        providesTags: tags,
        transformResponse: (response: { data: CostCenter }) => response.data,
      }),
    }),
  });

export default wbsCodeApi;
